/** Reads a redux-persist entry (`persist:<key>`, a JSON object of JSON-stringified fields) and removes it. */
export function takeReduxPersisted(key: string): Record<string, unknown> | undefined {
    const storageKey = `persist:${key}`;
    const raw = localStorage.getItem(storageKey);
    if (raw === null) return undefined;
    localStorage.removeItem(storageKey);

    try {
        const { _persist, ...fields } = JSON.parse(raw) as Record<string, unknown>;
        return Object.fromEntries(
            Object.entries(fields).map(([field, value]) => [field, typeof value === 'string' ? JSON.parse(value) : value]),
        );
    } catch {
        return undefined;
    }
}
